import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { RegionProvider } from "@/contexts/RegionContext";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FounderPage from "@/pages/FounderPage";
import ServicesPage from "@/pages/ServicesPage";
import TrainingPage from "@/pages/TrainingPage";
import CareersPage from "@/pages/CareersPage";
import PartnerPage from "@/pages/PartnerPage";
import CsrPage from "@/pages/CsrPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import CommunityImpact from "@/components/CommunityImpact";

function App() {
    return (
        <RegionProvider>
            <div className="App" data-testid="indoblitz-app">
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/founder" element={<FounderPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/training" element={<TrainingPage />} />
                        <Route path="/careers" element={<CareersPage />} />
                        <Route path="/partner" element={<PartnerPage />} />
                        <Route path="/csr" element={<CsrPage />} />
                        <Route path="/community-impact" element={<CommunityImpact />} />
                        <Route path="/faq" element={<FaqPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </RegionProvider>
    );
}

export default App;
